import { WidgetType } from './widgetTypes.js';
import OwnTodoWidget from './ownTodoWidget.js';
import EmployeeTodoWidget from './employeeTodoWidget.js';
import OpenVacationsWidget from './openVacationsWidget.js';
import DeadlinesWidget from './deadlinesWidget.js';
import NewMessagesWidget from './newMessagesWidget.js';
import ActiveEmployeeWidget from './activeEmployeeWidget.js';
import NotepadWidget from './notepadWidget.js';
import CompanyLogoWidget from './companyLogoWidget.js';
import LohnkostenBereichWidget from './lohnkostenBereichWidget.js';
import LohnkostenTrendWidget from './lohnkostenTrendWidget.js';

/**
 * Mapping von WidgetType -> Widget-Klassen-Konstruktor.
 * Neue systemdefinierte Widgets hier registrieren und in WidgetType / WidgetTypeMeta ergänzen.
 */
export const WidgetRegistry = Object.freeze({
    [WidgetType.EigeneTodos]: OwnTodoWidget,
    [WidgetType.MitarbeiterTodos]: EmployeeTodoWidget,
    [WidgetType.OffeneUrlaubsantraege]: OpenVacationsWidget,
    [WidgetType.Fristen]: DeadlinesWidget,
    [WidgetType.NeueMitteilungen]: NewMessagesWidget,
    [WidgetType.AktiveMitarbeiter]: ActiveEmployeeWidget,
    [WidgetType.Notizblock]: NotepadWidget,
    [WidgetType.Firmenlogo]: CompanyLogoWidget,
    [WidgetType.LohnkostenBereich]: LohnkostenBereichWidget,
    [WidgetType.LohnkostenTrend]: LohnkostenTrendWidget,
});
